export const GET_TRANSACTION = "GET_TRANSACTION";
export const GET_ALL_TRANSACTIONS = "GET_ALL_TRANSACTIONS";
export const GET_USER_TRANSACTIONS = "GET_USER_TRANSACTIONS";
export const ADD_TRANSACTION = "ADD_TRANSACTION";
export const CLEAR_TRANSACTION = "CLEAR_TRANSACTION";
export const CANCEL_TRANSACTION = "CANCEL_TRANSACTION";
export const CONFIRM_TRANSACTION = "CONFIRM_TRANSACTION";
export const GET_USER_TRANSACTION_TOTAL = "GET_USER_TRANSACTION_TOTAL";
